import React from 'react';

// Full-colour brand logo (transparent PNG) — sits directly on whatever
// background it's placed on, no badge/crop needed.
export const BrandLogo = ({ className = '' }) => (
  <img src="/logo-dow.png" alt="Drive on Wheels" className={`mx-auto w-full max-w-[160px] h-auto object-contain ${className}`} />
);

// "Drive on Wheels" wordmark. Uses currentColor so it adapts to its container
// (white on the dark sidebar). The road swoosh uses the brand orange accent.
export const Logo = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 170 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      x="0"
      y="22"
      fontFamily="Inter, sans-serif"
      fontSize="22"
      fontWeight="800"
      fill="currentColor"
    >
      Drive
    </text>
    <text
      x="64"
      y="22"
      fontFamily="Inter, sans-serif"
      fontSize="13"
      fontWeight="600"
      fill="#f97e2e"
    >
      on Wheels
    </text>
    {/* road swoosh */}
    <path d="M2 30 Q70 20 168 28" stroke="#f97e2e" strokeWidth="3" strokeLinecap="round" />
    <path d="M6 34 Q75 25 165 32" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.85" strokeDasharray="2 4" />
  </svg>
);
